import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import Drp_ProductGroup from '../ProductGroup/Drp_Group.js';
import Drp_ProductParentGroup from '../ProductGroup/Drp_Group.js';
import Auto_Product from '../Product/Auto_Product.js';
import Drp_Brand from '../ProductBrand/Drp_Brand.js'
import Drp_Branch from '../Branch/Drp_Branch.js'
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";
import { Modal } from "react-bootstrap";



const FactorIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const rowKey = 'Id';
    let navigate = useNavigate();
    const ProductRef = useRef()
    const GroupRef = useRef()
    const BrandRef = useRef()
    const BranchRef = useRef()
    const ParentGroupRef = useRef()
    const [List, setList] = useState([]);
    const [Id, setId] = useState(General.GuidEmpty())
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [ChangeActive, setChangeActive] = useState("-1");
    const [ChangeActiveModal, setChangeActiveModal] = useState(false);
    const [ErrorModal, setErrorModal] = useState(false);
    const [BranchId, setBranchId] = useState(General.GuidEmpty());
    const [ErrorList, setErrorList] = useState([]);
    const [GroupId, setGroupId] = useState("-1");
    const [GroupParentId, setGroupParentId] = useState("-1");
    const [BrandId, setBrandId] = useState("-1");
    const [ProductTitle, setProductTitle] = useState('');
    const [CustomerSearch, setCustomerSearch] = useState('');
    const [MobileSearch, setMobileSearch] = useState('');
    const [ProductId, setProductId] = useState(General.GuidEmpty());
    const [Code, setCode] = useState("");
    const [IsSend, setIsSend] = useState(-1);
    const [IsActive, setIsActive] = useState(1);
    const [BeginDate, setBeginDate] = useState(moment(new Date()).add("Day", -7));
    const [EndDate, setEndDate] = useState(moment(new Date()));
    const [expandedRowKeys, setExpandedRowKeys] = React.useState([0]);
    const [loading, setLoading] = React.useState(false)

    //#endregion

    const handleExpanded = (rowData) => {
        let open = false;
        const nextExpandedRowKeys = [];
        expandedRowKeys.forEach(key => {

            if (key === rowData[rowKey]) {
                open = true;
            } else if (key != undefined) {
                nextExpandedRowKeys.push(key);
            }
        });

        if (!open) {
            nextExpandedRowKeys.push(rowData[rowKey]);
        }

        setExpandedRowKeys(nextExpandedRowKeys);
    };

    const Product_Select = (e) => {
        setProductId(e.split("|")[0])
        setProductTitle(e.split("|")[1])
    }

    const Product_Change = (e) => {
        setProductId(General.GuidEmpty())
        if (e.split("|").length > 1) {
            setProductTitle(e.split("|")[1]);
            return;
        }
        setProductTitle(e);
        ProductRef.current.Bind(GroupParentId, GroupId, e)

    }

    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const Parent_Change = (value) => {
        setGroupParentId(value);
        setProductId(General.GuidEmpty());
        setProductTitle("");
        setGroupId("-1");
        GroupRef.current.BindGroupByParentId(0, value);
        ProductRef.current.Bind(value, -1, '')
    }

    const Brand_Change = (value) => {
        setBrandId(value);
    }

    const Branch_Change = (value) => {
        console.dir(value)
        setBranchId(value);
    }

    const Group_Change = (value) => {
        setGroupId(value);
        setProductId(General.GuidEmpty());
        setProductTitle("");
        ProductRef.current.Bind(GroupParentId, value, '')
    }


    //#region Methods


    const Search = () => {

        var RequestOptions = {
            data: {
                'FiscalYearId': FiscalYearId * 1,
                'Customer': CustomerSearch,
                'Mobile': MobileSearch,
                'Code': Code,
                'IsActive': IsActive,
                'IsSend': IsSend,
                'BranchId': BranchId,

            },
            url: General.ApiRoute() + "/Factor/SearchHeader",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'ProductId': ProductId,
                'GroupId': GroupId,
                'GroupParentId': GroupParentId,
                'BrandId': BrandId,
                'BeginDate': BeginDate != null ? moment(BeginDate.format()).format("jYYYY/jMM/jDD") : "",
                'EndDate': EndDate != null ? moment(EndDate.format()).format("jYYYY/jMM/jDD") : "",
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = []
                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Id: result.data[i].id,
                            Code: result.data[i].code,
                            FactorCode: result.data[i].factorCode,
                            Branch: result.data[i].branch,
                            Customer: result.data[i].customer,
                            Mobile: result.data[i].mobile,
                            CreateUser: result.data[i].createUser,
                            TotalPrice: result.data[i].totalPrice,
                            TotalReciept: result.data[i].totalReciept,
                            RegisterDate: result.data[i].registerDate,
                            children: result.data[i].children,
                            IsActive: result.data[i].isActive,
                            IsSend: result.data[i].isSend,
                            Editable: result.data[i].editable,

                        })
                    }
                    setList(tmp)
                }).catch((error) => {
                    console.dir(error)
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }



    const UpdateIsActive = () => {

        var RequestOptions = {
            data: {
                "Id": Id,
                "Code": Code,
                "IsActive": ChangeActive
            },
            url: General.ApiRoute() + "/Factor/UpdateIsActive",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        Search();
                        setChangeActiveModal(false)

                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }


    const UpdateSend = () => {

        var RequestOptions = {
            data: {
                "Id": Id,
                "Code": Code,
                "IsSend": 1
            },
            url: General.ApiRoute() + "/Factor/UpdateIsSend",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("به فاکتور شماره " + result.data.split("|")[1] + " تبدیل شده است")), 'topCenter')
                        Search();
                        setErrorModal(false);
                        setId(General.GuidEmpty); 
                        setCode("");

                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }


    const CheckUpdateSend = (id, code) => {
        setCode(code);
        setId(id);
        var RequestOptions = {
            data: {
                "Id": id
            },
            url: General.ApiRoute() + "/Factor/CheckUpdateIsSend",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    console.dir(result.data);
                    setErrorList(result.data);
                    setErrorModal(true);

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }



    const ShowEdit = (id) => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 22);
        myHeaders.append("Operation", 3);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')

                    }
                    else {
                        navigate("/InsertFactor")
                        localStorage.setItem("FactorHeaderId", id)
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )


    }

    const Print = (id) => {
        localStorage.setItem("FactorHeaderId", id)
        window.open("/Printfactor", "_blank");

    }



    const ShowNew = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 22);
        myHeaders.append("Operation", 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')
                    }
                    else {
                        navigate("/InsertFactor")
                        localStorage.setItem("FactorHeaderId", General.GuidEmpty())

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 22);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        ParentGroupRef.current.BindGroupByParentId(-1, 0);
                        BrandRef.current.BindBrand(-1);
                        BranchRef.current.Bind(General.GuidEmpty());
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const handelKeyDown = (e, row) => {
        if (e.key == "Enter") {
            Search();
        }
        if (e.shiftKey && e.code === "KeyN") {
            ShowNew();
        }

    }

    useEffect(() => {
        CheckPermission();
        document.title = "فاکتور ";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion







    return (

        <Layout title=" فاکتور">


            <div className="h-100 p-1" onKeyDown={handelKeyDown}>
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className={localStorage.getItem("CreateFactor_whitOutPrefactor") == "1" ? "m-1" : "hide"} onClick={ShowNew}>  جـــدید</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>  شعبه</label>
                            <Drp_Branch className="rs-input" value={BranchId} onChange={Branch_Change} ref={BranchRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>نام و نام خانوادگی مشتری</label>
                            <rsuite.Input value={CustomerSearch} className='FocusItem' onChange={(e) => setCustomerSearch(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>شماره همراه مشتری</label>
                            <rsuite.Input value={MobileSearch} onChange={(e) => setMobileSearch(e)} />
                        </rsuite.Col>

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>شماره فاکتور</label>
                            <rsuite.Input value={Code} onChange={(e) => setCode(e)} />
                        </rsuite.Col>

                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>وضعیت</label>
                            <select className="rs-input" onChange={(e) => setIsActive(e.target.value)} value={IsActive}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">غیر فعال </option>
                                <option value="1">فعال  </option>
                            </select>
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> وضعیت فاکتور</label>
                            <select className="rs-input" onChange={(e) => setIsSend(e.target.value)} value={IsSend}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">هیچ  کدام ار آیتم ها ارسال نشده است</option>
                                <option value="1">برخی آیتم ها ارسال شده است </option>
                                <option value="2">تمام آیتم ها ارسال شده است </option>


                            </select>
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> از تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />

                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>تا تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />
                        </rsuite.Col>

                    </rsuite.Row>
                    <rsuite.Row>


                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>برند   </label>
                            <Drp_Brand className="rs-input" value={BrandId} onChange={Brand_Change} ref={BrandRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>گروه   </label>
                            <Drp_ProductParentGroup className="rs-input" value={GroupParentId} onChange={Parent_Change} ref={ParentGroupRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>زیر گروه   </label>
                            <Drp_ProductGroup className="rs-input" value={GroupId} onChange={Group_Change} ref={GroupRef} />
                        </rsuite.Col>

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> محصول   </label>
                            <Auto_Product className="rs-input" value={ProductTitle} onChange={Product_Change} onSelect={Product_Select} ref={ProductRef} />
                        </rsuite.Col>




                    </rsuite.Row>

                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    rowKey={rowKey}
                                    rowExpandedHeight={rowData => {
                                        return (
                                            rowData.children.length == 1 ? 100 : rowData.children.length == 2 ? 160 : rowData.children.length * 75)
                                    }}

                                    height={500}
                                    data={List}
                                    expandedRowKeys={expandedRowKeys}
                                    loading={loading}
                                    renderRowExpanded={rowData => {
                                        return (
                                            <div>
                                                <rsuite.Table
                                                    data={rowData.children}
                                                    loading={loading}
                                                    autoHeight={true}
                                                    className='text-black-50'
                                                    wordWrap
                                                >
                                                    <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                        <rsuite.Table.HeaderCell> وضعیت </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {rowData.storeRoom}
                                                                        <br />
                                                                        <small>
                                                                            {rowData.transferTypeComment}
                                                                        </small>
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                        <rsuite.Table.HeaderCell>محصول </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='product' />
                                                    </rsuite.Table.Column>

                                                    <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                        <rsuite.Table.HeaderCell>برند </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='productBrand' />
                                                    </rsuite.Table.Column>

                                                    <rsuite.Table.Column width={100} >
                                                        <rsuite.Table.HeaderCell>تعداد</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='count' />
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell>قیمت واحد (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.price)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell>تخفیف واحد (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.discountPrice)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell>مالیات واحد (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.tax)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell>قیمت کل (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.totalPrice)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                </rsuite.Table>
                                            </div>
                                        );
                                    }}

                                >

                                    <rsuite.Table.Column className="w-10p" align="center" fixed >
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {expandedRowKeys.some(key => key === rowData[rowKey]) ? (
                                                        <BiIcon.BiMinusCircle size='12px' color='red' appearance="subtle"
                                                            onClick={() => {
                                                                handleExpanded(rowData);
                                                            }} />
                                                    ) : (
                                                        <BiIcon.BiPlusCircle size='12px' color='green' appearance="subtle"
                                                            onClick={() => {
                                                                handleExpanded(rowData);
                                                            }} />
                                                    )}

                                                    &nbsp;&nbsp;
                                                    {rowData.IsSend == 0 ?
                                                        <rsuite.Tag color='red'>{rowData.row}</rsuite.Tag>
                                                        : rowData.IsSend == 1 ?
                                                            <rsuite.Tag color='yellow'>{rowData.row}</rsuite.Tag>
                                                            :
                                                            <rsuite.Tag color='green'>{rowData.row}</rsuite.Tag>
                                                    }



                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell> شعبه</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.TotalPrice - rowData.TotalReciept != 0 ?
                                                        <p className='text-danger'>{rowData.Branch}</p>
                                                        : <p>{rowData.Branch}</p>
                                                    }
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>شماره فاکتور</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.TotalPrice - rowData.TotalReciept != 0 ?
                                                        <p className='text-danger'>{rowData.Code}</p>
                                                        : <p>{rowData.Code}</p>
                                                    }
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell> نام مشتری </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.TotalPrice - rowData.TotalReciept != 0 ?
                                                        <p className='text-danger'>{rowData.Customer}</p>
                                                        : <p>{rowData.Customer}</p>
                                                    }
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>شماره همراه</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.TotalPrice - rowData.TotalReciept != 0 ?
                                                        <p className='text-danger'>{rowData.Mobile}</p>
                                                        : <p>{rowData.Mobile}</p>
                                                    }
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>تاریخ</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.TotalPrice - rowData.TotalReciept != 0 ?
                                                        <p className='text-danger'>{rowData.RegisterDate}</p>
                                                        : <p>{rowData.RegisterDate}</p>
                                                    }
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>کاربر</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.TotalPrice - rowData.TotalReciept != 0 ?
                                                        <p className='text-danger'>{rowData.CreateUser}</p>
                                                        : <p>{rowData.CreateUser}</p>
                                                    }
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>مبلغ فاکتور</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.TotalPrice - rowData.TotalReciept != 0 ?
                                                        <p className='text-danger'>{PN.sliceNumber(rowData.TotalPrice)}</p>
                                                        : <p>{PN.sliceNumber(rowData.TotalPrice)}</p>
                                                    }
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>مبلغ پرداختی</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.TotalPrice - rowData.TotalReciept != 0 ?
                                                        <p className='text-danger'>{PN.sliceNumber(rowData.TotalReciept)}</p>
                                                        : <p>{PN.sliceNumber(rowData.TotalReciept)}</p>
                                                    }
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fixed="right" width={60} >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item className={rowData.IsActive == 1 && rowData.Editable == 1 ? '' : "hide"} onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.IsSend != 2 && rowData.IsActive == 1 ? '' : "hide"} onClick={() => CheckUpdateSend(rowData.Id, rowData.Code)}>ارسال </rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.TotalReciept == 0 ? '' : "hide"} onClick={() => (setChangeActiveModal(true), setId(rowData.Id), setChangeActive(rowData.IsActive == 1 ? 0 : 1), setCode(rowData.Code))}>{rowData.IsActive == 1 ? <>غیر فعال</> : <> فعال</>}  </rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.IsActive == 1 && rowData.Editable == 1 ? '' : "hide"} onClick={() => (localStorage.setItem("FactorHeaderId", rowData.Id), localStorage.setItem("BackPage", "Factor"), navigate("/InsertFacorReciept"))}> دریافت  </rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => Print(rowData.Id)}>چاپ   </rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>
                            <small><b> Shift+N :</b> جدید<b>| Enter :</b> جستجو </small>
                        </rsuite.Col>
                    </rsuite.Row>

                </rsuite.Panel >
            </div >

            <rsuite.Modal open={ChangeActiveModal} onClose={() => setChangeActive(false)}>
                <rsuite.Modal.Header>
                    <rsuite.Modal.Title><b> {ChangeActive == 1 ? <>فعال</> : <>غیر فعال</>} کردن اطلاعات </b></rsuite.Modal.Title>
                </rsuite.Modal.Header>
                <rsuite.Modal.Body>
                    <div className="mt-3 Font15">

                        آیا از {ChangeActive == 1 ? <>فعال</> : <>غیر فعال</>} کردن  فاکتور {Code} اطمینان دارید؟!
                    </div>
                </rsuite.Modal.Body>
                <rsuite.Modal.Footer>
                    <rsuite.Button appearance="primary" color={ChangeActive == 0 ? "red" : "green"} onClick={UpdateIsActive}>
                        بلی
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setChangeActiveModal(false)}>
                        خیر
                    </rsuite.Button>
                </rsuite.Modal.Footer>
            </rsuite.Modal>

            <Modal show={ErrorModal} onHide={() => setErrorModal(false)} size="xl" backdrop="static" keyboard={false}>
                <Modal.Header >

                    <Modal.Title className='fs-5'> ارسال آیتم های فاکتور {Code} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>

                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                {ErrorList.length > 0 ?
                                    <rsuite.Table
                                        height={500}
                                        data={ErrorList}
                                        wordWrap="break-word"
                                    >
                                        <rsuite.Table.Column flexGrow={1} resizable>
                                            <rsuite.Table.HeaderCell> توضیحات </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.validation == false ?
                                                            <p className='text-danger'>{rowData.comment}</p>
                                                            : !rowData.title.includes('OK') ? <p>{rowData.comment}</p>
                                                                :
                                                                <></>
                                                        }
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>
                                    </rsuite.Table>
                                    :
                                    <>
                                        از انتقال تمام آیتم های فاکتور اطمینان دارید ؟
                                    </>
                                }

                            </rsuite.Col>
                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color='green' disabled={ErrorList.length > 0 && ErrorList.filter(x => x.validation == false).length > 0 ? true : false} onClick={() => UpdateSend()}>
                        ثبت
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => (setErrorModal(false), setId(General.GuidEmpty), setCode(""))}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

        </Layout >


    )
}

export default FactorIndex;